import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import { IAllocationConfigListResponse } from 'redux/types/GetAllocationConfigList.type';
import { allocationEngineEndpoints } from 'services/api/endPoints';

import { HTTPClient } from '../../../services/api/http-client';
import {
  AllocationConfigPayload,
  fetchGetAllocationConfigList,
  fetchGetAllocationConfigListFailed,
  fetchGetAllocationConfigListSucceeded,
} from '../../slice/allocation-config/GetAllocationConfigList.slice';

export function* getAllocationConfigListSaga({
  payload,
}: PayloadAction<AllocationConfigPayload>) {
  try {
    const { recordLimit, lenderId, filters = [] } = payload;
    const { offset, limit } = recordLimit;
    const result: AxiosResponse<IAllocationConfigListResponse> =
      yield HTTPClient.PostRequest(
        allocationEngineEndpoints.GET_CREATED_ALLOCATION_CONFIG_LIST(lenderId),
        {
          offset,
          limit,
          filters,
        }
      );
    if (result?.data) {
      const { allocationConfigs, ...restData } = result?.data;

      const updatedAllocationConfigs = allocationConfigs.map((config) => {
        const { allocationLogic } = config;

        const updatedConditions = allocationLogic.operations[0].conditions.map(
          (condition) => ({
            ...condition,
            values: condition.values || [],
          })
        );

        return {
          ...config,
          allocationLogic: {
            ...allocationLogic,
            operations: [
              {
                ...allocationLogic.operations[0],
                conditions: updatedConditions,
              },
            ],
          },
        };
      });

      yield put(
        fetchGetAllocationConfigListSucceeded({
          allocationConfigs: updatedAllocationConfigs,
          ...restData,
        })
      );
    } else {
      throw new Error('Invalid response');
    }
  } catch (error) {
    yield put(
      fetchGetAllocationConfigListFailed({
        error: { message: 'Failed to get allocation config list' },
      })
    );
  }
}

export function* watchGetAllocationConfigListSaga() {
  yield takeLatest(
    fetchGetAllocationConfigList.type,
    getAllocationConfigListSaga
  );
}
